// Library
import { Box, BoxProps } from '@chakra-ui/react';

/**
 * `DropdownBlanket` is a simple wrapper component that occupies the full viewport
 * and is used to capture clicks that happen outside an open dropdown,
 * allowing the dropdown to close when a user clicks outside it.
 *
 * @component
 * @param {BoxProps} props - The properties that define the `DropdownBlanket` component. These are the same properties that can be provided to a Box component in Chakra UI.
 *
 * @returns {ReactElement} Returns a component that occupies the full viewport and captures all clicks.
 */
export const DropdownBlanket = (props: BoxProps) => (
  <Box position='fixed' top={0} bottom={0} left={0} right={0} zIndex={1} {...props} />
);
